// projects/humanresources-personnel/src/assets/i18n/*/hr-per-education.json
export class HrPerEducationKey {
    private static readonly keyPrefix = 'hrPerEducation';
    public static title = `${HrPerEducationKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerEducationKey.keyPrefix}.pageHeader`;
    public static subtype = `${HrPerEducationKey.keyPrefix}.subtype`;
    public static subtypeId = `${HrPerEducationKey.keyPrefix}.subtypeId`;
    public static institution = `${HrPerEducationKey.keyPrefix}.institution`;
    public static institutionId = `${HrPerEducationKey.keyPrefix}.institutionId`;
    public static integrationSource = `${HrPerEducationKey.keyPrefix}.integrationSource`;
    public static integrationGetDate = `${HrPerEducationKey.keyPrefix}.integrationGetDate`;
    public static faculty = `${HrPerEducationKey.keyPrefix}.faculty`;
    public static facultyId = `${HrPerEducationKey.keyPrefix}.facultyId`;
    public static branchOfStudy = `${HrPerEducationKey.keyPrefix}.branchOfStudy`;
    public static branchOfStudyId = `${HrPerEducationKey.keyPrefix}.branchOfStudyId`;
    public static graduationDate = `${HrPerEducationKey.keyPrefix}.graduationDate`;
    public static duration = `${HrPerEducationKey.keyPrefix}.duration`;
    public static gradePointAverage = `${HrPerEducationKey.keyPrefix}.gradePointAverage`;
    public static certificateNumber = `${HrPerEducationKey.keyPrefix}.certificateNumber`;
    public static preparatoryClass = `${HrPerEducationKey.keyPrefix}.preparatoryClass`;
    public static equivalenceSchool = `${HrPerEducationKey.keyPrefix}.equivalenceSchool`;
    public static equivalenceBranch = `${HrPerEducationKey.keyPrefix}.equivalenceBranch`;
    public static equivalenceDate = `${HrPerEducationKey.keyPrefix}.equivalenceDate`;
    public static abroadEducation = `${HrPerEducationKey.keyPrefix}.abroadEducation`;
    public static hrmAcademicTitleUuid = `${HrPerEducationKey.keyPrefix}.hrmAcademicTitleUuid`;
}
